import { useState, useEffect } from 'react';
import NewsService, { NewsArticle } from '../services/newsService';

export const useNews = (refreshInterval: number = 900000) => { // 15 minutes
  const [articles, setArticles] = useState<NewsArticle[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        const data = await NewsService.getDisasterNews();
        setArticles(data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch news');
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
    const interval = setInterval(fetchNews, refreshInterval);
    return () => clearInterval(interval);
  }, [refreshInterval]);

  return { articles, loading, error };
};